var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"250px","width":"100%"},attrs:{"id":"videoplayer"}}),_c('div',{attrs:{"id":"video_container"}},_vm._l((_vm.courseResourceTreeData.children),function(item,index){return _c('ctree',{key:index,attrs:{"treelist":item,"treelistindex":0},on:{"treeTap":_vm.coursetreeplay}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }